import React from "react";
import {SellingValue} from '../../../components/common/selling.value.js';

// Interface for component props
interface InfoBlockItemProps {
	text: string;
	value?: string | number;
	paddingNull?: boolean;
}

export const InfoBlockItem = ( props: InfoBlockItemProps ) => {

	return(
		<div className={"info-block-item"}>
			<SellingValue text={props.text} value={props.value} paddingNull={props.paddingNull}/>
		</div>
	);
};